


// src/components/SearchBar.tsx
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface SearchBarProps {
    placeholder?: string;
    value?: string;
    onChange?: (value: string) => void;
    onCancel?: () => void;
    showCancel?: boolean;
}

export const SearchBar: React.FC<SearchBarProps> = ({
                                                        placeholder = "Поиск товаров...",
                                                        value = "",
                                                        onChange,
                                                        onCancel,
                                                        showCancel = false
                                                    }) => {
    const navigate = useNavigate();

    const handleFocus = () => {
        navigate('/search');
    };

    return (
        <div className="search-bar-container">
            <div className="search-input-wrapper">
                <span className="search-icon">🔍</span>
                <input
                    type="text"
                    value={value}
                    onChange={(e) => onChange?.(e.target.value)}
                    onFocus={handleFocus}
                    placeholder={placeholder}
                    className="search-input"
                />
                {value && !showCancel && (
                    <button onClick={() => onChange?.('')} className="search-clear-btn">
                        ✕
                    </button>
                )}
            </div>
            {showCancel && (
                <button onClick={onCancel} className="search-cancel-right">
                    Отмена
                </button>
            )}
        </div>
    );
};
